import { Component, OnInit, ViewEncapsulation, AfterViewInit} from '@angular/core';
import { DataSharing } from '../../helpers/core/data.sharing';
declare let $: any;

@Component({
    selector: 'app-left-display',
    templateUrl: './aside-left-display-disabled.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class AsideLeftDisplayDisabledComponent implements OnInit {
    public _asset_label: any;
    public _is_wssp: any;
    constructor() {

    }
    ngOnInit() {
        this._asset_label = 'Asset';
        this._is_wssp = false;
        if(DataSharing.domain_id()==16){
            this._asset_label = 'Vehicle';
            this._is_wssp = true;
        }
    }

    ngAfterViewInit() {
        let menu = $('.nav-sidebar');
        let item = $(menu).find('a[href="' + window.location.pathname + '"]').addClass('active');
    }

}
